import { render } from "./ApartmentAvailability.vue?vue&type=template&id=71c079be&scoped=true"
import script from "./ApartmentAvailability.vue?vue&type=script&lang=js"
export * from "./ApartmentAvailability.vue?vue&type=script&lang=js"

import "./ApartmentAvailability.vue?vue&type=style&index=0&id=71c079be&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c079be"]])

export default __exports__